// extracted by mini-css-extract-plugin
export default {"report_class":"retention_report_class__3ninf","pbiLoadingPlaceholder":"retention_pbiLoadingPlaceholder__ri-VY","fadeInOut":"retention_fadeInOut__ycIgY"};